import PlanInfo from 'components/Common/PlanInfo';
import HeaderTitle from './HeaderTitle';

function CustomHeader() {
  return (
    <div className="common-header-hyp-info">
      <span className="common-header-title">
        <HeaderTitle />
      </span>
      <PlanInfo />
    </div>
  );
}

export default CustomHeader;
